module.exports = __webpack_public_path__ + "912edb7c35edb35a3eab1f061e874c4b.MP3";